(function() {
    'use strict';

    angular
        .module('fileUploadApp')
        .controller('UserManagementDialogNewController',UserManagementDialogNewController);

    UserManagementDialogNewController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', '$http', '$state'];

    function UserManagementDialogNewController ($stateParams, $uibModalInstance, entity, User, $http, $state) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;
        vm.loadRole = loadRole;
        vm.resetPassword = resetPassword;
        vm.isEdit=$state.is('user-management-new.edit');

        
        vm.loadRole();
        
        
        
        function loadRole(){
        	if(vm.user.authorities){
        		angular.forEach(vm.user.authorities,function(a){
                	if(a=='ROLE_CLIENT'){
                		vm.user.role='client';
                	}
                	else if(a=='ROLE_PROCESSOR'){
                		vm.user.role='processor';
                	}
                	else if(a=='ROLE_ADMIN'){
                		vm.user.role='admin';
                	}
                });
        	}
        	else if(vm.isEdit){
        		$http.get('api/users/'+$stateParams.login).then(function(res){
        			var u=res.data;
        			angular.forEach(u.authorities,function(a){
                    	if(a=='ROLE_CLIENT'){
                    		vm.user.role='client';
                    	}
                    	else if(a=='ROLE_PROCESSOR'){
                    		vm.user.role='processor';
                    	}
                    	else if(a=='ROLE_ADMIN'){
                    		vm.user.role='admin';
                    	}
                    });
        		});
        		
        	}
        	else{
        		vm.user.role='client';
        	}
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
        	if(vm.user.role=='client'){
        		vm.user.authorities=['ROLE_USER','ROLE_CLIENT'];
        	}
        	if(vm.user.role=='processor'){
        		vm.user.authorities=['ROLE_USER','ROLE_PROCESSOR'];
        	}
        	if(vm.user.role=='admin'){
        		vm.user.authorities=['ROLE_USER','ROLE_ADMIN'];
        	}
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                vm.user.langKey = 'en';
                console.log(vm.user);
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
        
        function resetPassword(){
        	$http({
    			url: 'api/account/reset_password/admin',
    			method: 'POST',
    			data: vm.user.id
    		}).then(function(response) {
    			console.log(response);
    			if(response.status==200){
    				toastr.success("Reset Password email was sent.");
    			}
    			//$scope.loadRules();
    		},
    		function(response) {
    			toastr.error("Error occur when reset password.");
    			//$scope.loadRules();
    		})
        }
    }
})();
